var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PageLayout,{staticClass:"hold-single",attrs:{"title":"Холд","back-route":"/affiliates/hold"}},[_c('div',{staticClass:"hold-single__content"},[_c(_setup.HoldFilters),_c(_setup.HoldConversions)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }